import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { MainPanel } from '@calendly/booking-kit'

import Container from 'components/layout/container'
import ContentWrapper from 'components/layout/content_wrapper'
import GoogleAnalytics from 'services/analytics/google'
import FbPixel from 'services/analytics/facebook_pixel'
import EmbedAnalytics from 'services/analytics/embed'
import { SchedulingLinkContainer } from 'components/scheduling_links'
import { useProfile } from 'components/use_profile'

import Dossier from './dossier'
import EventTypes from './event_types'
import { LandingPageWrapper } from './landing_page_wrapper'
import { Bricks, CookieSettingsButton } from './styles'

export default function SelectEventType() {
  const { search: searchString } = useLocation()
  const profile = useProfile()

  useEffect(() => {
    GoogleAnalytics.userTrackEvent('invitee_scheduling_page')
    FbPixel.trackCustom('invitee_scheduling_page')
    EmbedAnalytics.track('profile_page_viewed')
  }, [])

  if (!profile) return null

  if (profile.is_landing_page) {
    return (
      <SchedulingLinkContainer expanded>
        <LandingPageWrapper />
      </SchedulingLinkContainer>
    )
  }

  return (
    <Container expanded>
      <MainPanel>
        <ContentWrapper>
          <Dossier />
          <Bricks>
            <EventTypes searchString={searchString} />
          </Bricks>
          <CookieSettingsButton />
        </ContentWrapper>
      </MainPanel>
    </Container>
  )
}
